import { api } from '@/lib/axios';

export enum NotificationTargetType {
  USER = 'USER',
  GROUP = 'GROUP',
  ALL = 'ALL',
}

export enum NotificationType {
  INFO = 'INFO',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
  TASK = 'TASK',
  FLOW = 'FLOW',
  BOARD = 'BOARD',
  CLIENT = 'CLIENT',
  ORDER = 'ORDER',
  RESERVATION = 'RESERVATION',
}

export interface Notification {
  id: string;
  tenantId: string;
  targetType: NotificationTargetType;
  targetId: string | null;
  type: NotificationType;
  title: string;
  message: string;
  icon: string | null;
  link: string | null;
  metadata: Record<string, any> | null;
  sourceType: string | null;
  sourceId: string | null;
  read: boolean;
  readAt: string | null;
  expiresAt: string | null;
  createdAt: string;
  updatedAt: string;
  isRead?: boolean; // Calculado para notificacoes coletivas
}

export interface NotificationQueryParams {
  type?: NotificationType;
  unreadOnly?: boolean;
  page?: number;
  limit?: number;
}

export interface PaginatedNotifications {
  data: Notification[];
  meta: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export interface CreateNotificationDto {
  targetType: NotificationTargetType;
  targetId?: string;
  type?: NotificationType;
  title: string;
  message: string;
  icon?: string;
  link?: string;
  metadata?: Record<string, any>;
  sourceType?: string;
  sourceId?: string;
  expiresAt?: string;
}

export const notificationsService = {
  async getAll(params?: NotificationQueryParams): Promise<PaginatedNotifications> {
    const response = await api.get<PaginatedNotifications>('/notifications', { params });
    return response.data;
  },

  async getUnreadCount(): Promise<{ count: number }> {
    const response = await api.get<{ count: number }>('/notifications/unread-count');
    return response.data;
  },

  async create(data: CreateNotificationDto): Promise<Notification> {
    const response = await api.post<Notification>('/notifications', data);
    return response.data;
  },

  async markAsRead(notificationIds: string[]): Promise<{ marked: number }> {
    const response = await api.post<{ marked: number }>('/notifications/mark-read', {
      notificationIds,
    });
    return response.data;
  },

  async markAllAsRead(): Promise<{ success: boolean }> {
    const response = await api.post<{ success: boolean }>('/notifications/mark-all-read');
    return response.data;
  },

  async delete(id: string): Promise<{ success: boolean }> {
    const response = await api.delete<{ success: boolean }>(`/notifications/${id}`);
    return response.data;
  },
};
